// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"5bf7ffd2","239":"22615065","455":"38c93cda","762":"a574c6b1","977":"86d95656"}[chunkId] + ".chunk.js";
};